export const animations = {
  durations: {
    fast: '150ms',
    normal: '250ms',
    slow: '350ms',
    delight: '500ms',
  },
  easings: {
    linear: 'linear',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    bounce: 'cubic-bezier(0.34, 1.56, 0.64, 1)', // Snappy spring bounce
  },
  presets: {
    fadeIn: 'fadeIn 0.25s cubic-bezier(0, 0, 0.2, 1)',
    slideInRight: 'slideInRight 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    scaleIn: 'scaleIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
  }
};

export default animations;
